<template>
  <UpgradePlanModal v-model:open="visible" />
</template>

<script setup>
import UpgradePlanModal from "./UpgradePlanModal.vue"
import useUpgradeModal from "@/composables/upgradeModal.js"

const { visible } = useUpgradeModal()
</script>
